import React from 'react';
import { Helmet } from 'react-helmet-async';

export const PrivacyPolicyPage = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | DNB Calgary</title>
        <meta name="description" content="Privacy Policy for DNB. Learn how we collect, use, and protect your personal information." />
      </Helmet>

      <main data-testid="privacy-policy-page" className="page-transition">
        <section className="pt-32 pb-16 section-tint">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="font-heading font-extrabold text-3xl sm:text-4xl text-[#0F172A] mb-8">
              Privacy Policy
            </h1>
            
            <div className="prose prose-lg max-w-none text-slate-600">
              <p className="text-sm text-slate-500 mb-8">Last updated: March 2026</p>
              
              <h2 className="font-heading font-bold text-xl text-[#0F172A] mt-8 mb-4">
                Information We Collect
              </h2>
              <p>
                When you contact DNB through our website, we collect information you provide directly, including:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Name and contact information (phone number, email address)</li>
                <li>Service address</li>
                <li>Details about your service request</li>
              </ul>

              <h2 className="font-heading font-bold text-xl text-[#0F172A] mt-8 mb-4">
                How We Use Your Information
              </h2>
              <p>
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Respond to your service requests and inquiries</li>
                <li>Schedule and provide plumbing, heating, and gas fitting services</li>
                <li>Send appointment reminders and service updates</li>
                <li>Improve our services and customer experience</li>
              </ul>

              <h2 className="font-heading font-bold text-xl text-[#0F172A] mt-8 mb-4">
                Information Sharing
              </h2>
              <p>
                We do not sell, trade, or rent your personal information to third parties. We may share your information with:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Service providers who assist us in operating our business</li>
                <li>Regulatory authorities when required by law</li>
              </ul>

              <h2 className="font-heading font-bold text-xl text-[#0F172A] mt-8 mb-4">
                Data Security
              </h2>
              <p>
                We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
              </p>

              <h2 className="font-heading font-bold text-xl text-[#0F172A] mt-8 mb-4">
                Your Rights
              </h2>
              <p>
                You have the right to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt out of marketing communications</li>
              </ul>

              <h2 className="font-heading font-bold text-xl text-[#0F172A] mt-8 mb-4">
                Contact Us
              </h2>
              <p>
                If you have questions about this Privacy Policy or our data practices, please contact us:
              </p>
              <p className="mt-4">
                <strong>DNB</strong><br />
                Phone: 403-615-8770<br />
                Email: Radinovicw@shaw.ca<br />
                Calgary, Alberta, Canada
              </p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default PrivacyPolicyPage;
